export default __webpack_public_path__ + "static/media/i_bus-gen_bl.473dc58e.svg";